import z from 'zod'
import { RadiiResponse } from 'src/common-services/types/base-types'
import { DemoMultiPolygonRequest } from 'src/common-services/types/demo-types'

export const consumerSpendRadiiRequestSchema = z.object({
  lat: z.number(),
  lng: z.number(),
  radii: z.array(z.number().or(z.string())),
})
export type ConsumerSpendRadiiRequest = z.infer<typeof consumerSpendRadiiRequestSchema>

export type ConsumerSpendDatum = {
  total: number
  food: number
  alcohol: number
  housing: number
  apparel: number
  transportation: number
  health: number
  entertainment: number
  personal_care: number
  reading: number
  education: number
  tobacco: number
  misc: number
  cash: number
  insurance: number
  total_retail: number
  total_non_retail: number
}

export const consumerSpendRadiusDataSchema = z.object({
  currentYear: z.record(z.string(), z.number()),
  fiveYear: z.record(z.string(), z.number()),
})
export type ConsumerSpendRadiusData = z.infer<typeof consumerSpendRadiusDataSchema>

export type ConsumerSpendMultiPolygonRequest = DemoMultiPolygonRequest

export type ConsumerSpendResponse = RadiiResponse<ConsumerSpendRadiusData>
